import { getLanguage } from '@works-web/settings/modules/browser';
import axios from 'axios';
import Cookie from 'js-cookie';
import { CommonService, UserOptionName } from './CommonService';

const _lang = getLanguage();

const langSource = (function () {
  return (
    {
      en_US: 'en',
      ko_KR: 'ko',
      zh_CN: 'zh-CN',
      ja_JP: 'ja',
      zh_TW: 'zh-TW',
    }[_lang] || _lang
  );
})();

export class GeneralService {
  static async initAutoTrans() {
    const smartTransId = this.getSmartTransId();
    const list = await this.getAutoTransList();
    const sysLang = this.getSysLang();
    let checkedData = null;
    if (!smartTransId) {
      checkedData = list.find((item) => {
        return item.value == sysLang;
      });
    } else {
      checkedData = list.find((item) => {
        return item.value == smartTransId;
      });
      if (!checkedData) {
        checkedData = list.find((item) => {
          return item.value == sysLang;
        });
      }
    }
    if (!checkedData) {
      checkedData = list[0];
    }
    const data = { list: list, selected: checkedData };
    return data;
  }

  static getIDCLang = () => {
    let smartTransId = 'ko';
    let locLang = Cookie.get('WORKS_RE_LOC');

    locLang = locLang == null || locLang == '' ? 'kr' : locLang;
    locLang = locLang.toLowerCase();

    if (locLang.indexOf('kr') > -1) {
      locLang = 'ko';
    } else if (locLang.indexOf('ja') > -1 || locLang.indexOf('jp') > -1) {
      locLang = 'ja';
    }
    smartTransId = locLang;
    return smartTransId;
  };

  static getSmartTransId = () => {
    let smartTransId = CommonService.getOptionValue(
      UserOptionName.Smart_Translate,
    );
    smartTransId =
      smartTransId == null || smartTransId == ''
        ? this.getIDCLang()
        : smartTransId;
    return smartTransId;
  };

  static formatTransBot = (languageName, translateList, isAuto) => {
    let list = [];
    if (isAuto) {
      for (let i = 0; i < translateList.length; i++) {
        const item = translateList[i];
        let autoItem = {
          label: languageName[item],
          value: item,
        };
        list.push(autoItem);
      }
      return list;
    }
    for (let i = 0; i < translateList.length; i++) {
      const item = translateList[i];
      const srcLang = item.language1;
      const targetList = item.language2;
      let langItem = {
        src: srcLang,
        srcLabel: languageName[srcLang],
        targetList: [],
      };
      for (let j = 0; j < targetList.length; j++) {
        const tItem = targetList[j];
        let targetItem = null;
        for (let langKey in tItem) {
          targetItem = {
            target: langKey,
            targetLabel: languageName[langKey],
            id: tItem[langKey],
          };
        }
        langItem.targetList.push(targetItem);
      }
      list.push(langItem);
    }
    return list;
  };

  static async getAutoTransList() {
    const response = await axios({
      method: 'get',
      url: `/p/translation/api/v1/getLanguages?displayLanguage=${_lang}`,
      headers: {
        'X-SERVICE-ID': 'message',
      },
    });
    if (response.status === 200 && response.data.languages) {
      let languageNames = response.data.languages.map((item) => {
        let source = item.source;
        return {
          label: source.name,
          value: source.language,
        };
      });
      return languageNames;
    }
  }

  static getSysLang = () => {
    return langSource == 'zh_CN'
      ? 'zh-CN'
      : langSource == 'zh_TW'
        ? 'zh-TW'
        : langSource;
  };
}
